import { useCallback, useEffect } from 'react';
import produce from 'immer';
import { v4 as uuid4 } from 'uuid';
import type { BfInfoType, NestedFlowNodeType } from './types';
import { ChangeType } from '../../types';
import type { MoreInfo } from '../../types';
import useNodeCrud from '../_base/hooks/use-node-crud';
import { useNodesReadOnly } from '../../hooks';

const useConfig = (id: string, payload: NestedFlowNodeType) => {
  const { nodesReadOnly: readOnly } = useNodesReadOnly();
  const { inputs, setInputs } = useNodeCrud<NestedFlowNodeType>(id, payload);


  const handleBfInfoChange = useCallback(
      (value: BfInfoType) => {
        const newInputs = produce(inputs, (draft: NestedFlowNodeType) => {
          if (draft.detail) {
            draft.detail.nestedFlowInfo = value;
          }
        });
        setInputs(newInputs);
      },
      [inputs, setInputs]
  )

  const handleDescChange = useCallback(
      (value: string) => {
        const newInputs = produce(inputs, (draft: NestedFlowNodeType) => {
          draft.detail.desc = value;
        });
        setInputs(newInputs);
      },
      [inputs, setInputs]
  )





  return {
    readOnly,
    inputs,
    handleBfInfoChange,
    handleDescChange
  };
};

export default useConfig;
